import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ResponsiveTabs from 'components/ResponsiveTabs/ResponsiveTabs';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';
import GrillaEffect from 'views/Grillas/GrillaEffect';
import dayjs from 'dayjs';
import DataLabel from 'views/Cards/DataLabel';

function PagosEmitidos() {
  const defaultFecha = [
    { id: 'fecha_op', value: [dayjs().subtract(4, 'month'), dayjs(new Date())] }
  ];
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([...defaultFecha]);
  const [tab, setTab] = useState(0);

  const columnNames = {
    fecha_op: 'Fecha OP',
    numero_op: 'Numero OP',
    importe_cpte: 'Importe',
    tipo_cpte: 'Tipo Cbte.',
    numero_cpte: 'Numero Cbte.',
    importe_cancelado: 'Cancelado',
    importe_retenciones: 'Retenciones',
    importe_op_neto: 'Neto',
    cuenta_financiera: 'Cta. Financiera',
    rubro: 'Rubro',
    nombre_proveedor: 'Proveedor',
  };

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/18`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const GenerarPdf = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/18`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      const doc = new jsPDF();
      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: 'left',
          valign: 'center',
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardBody>
          {/* KPI Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 32}
                    filters={filters} label={"TOTAL PAGOS EMITIDOS"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 33}
                    filters={filters} label={"CANT. COMPROBANTES"} isMoney={false} />
                </CardBody>
              </Card>
            </Grid>
            {/* BOTONES EXPORTAR — pendiente activar
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody>
                  (botones futuros aquí)
                </CardBody>
              </Card>
            </Grid>
            */}
          </Grid>
          <Card sx={{ p: 2, my: 1 }}>
            <CardBody>
              <ResponsiveTabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                tabs={[
                  { label: 'Comprobantes' },
                  { label: 'Formas de Pago' },
                ]}
              />
              {tab === 0 && (
                <Box pt={1}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                    <GrillaEffect
                      data={data} updateData={setData}
                      filters={filters} updateFilters={setFilters}
                      idRemoto={18}
                      colsHeaders={columnNames} />
                  </LocalizationProvider>
                </Box>
              )}
              {tab === 1 && <Box pt={1} />}
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Box>
  );
}

export default PagosEmitidos;
